import type { OrchestratedQuery } from "@/domains/library"

import type { ILockRefreshStrategy } from "./interfaces"
import type { LockApiData } from "./types"

/**
 * Implementation of ILockRefreshStrategy that refreshes locks by forcing
 * execution of the orchestrator's API locks query.
 */
export class LockOrchestratorRefreshStrategy implements ILockRefreshStrategy {
  constructor(private readonly loadApiLocksQuery: OrchestratedQuery<Array<LockApiData>>) {}

  async refresh(): Promise<void> {
    await this.loadApiLocksQuery.forceExecute()
  }
}
